import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GridStack } from "gridstack";

import { useTranslation } from "react-i18next";
import BankTable from "./BankTable/BankTable";
import DMSHeader from "../../DMSHeader/DMSHeader";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";

// Component for rendering bank table data
const BankManagement = () => {
  // Hook for internationalization/translation support
  const { t } = useTranslation();

  // Initialize GridStack layout system on component mount
  useEffect(() => {
    GridStack.init();
  }, []);

  // Get current route location and state data
  const location = useLocation();

  // Configuration array defining grid layout with header and table components
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      // Header component with bank details title and export functionality
      component: (
        <DMSHeader
          title={t("Bank Details")}
          fileName="Banks Details"
          showmenu={true}
          showImportDropDownLabel={false}
          showdownload={true}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      // Main bank data table component with location state passed as prop
      component: <BankTable locationInstance={location.state} />,
    },
  ];

  // Render grid-based layout container with configured layout data
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default BankManagement;
